import { ErrorOutlineRounded } from '@material-ui/icons'
import React from 'react'
import { useTheme } from 'styled-components'

import { pluralize } from '../../../../utils/textTools'
import {
  AutoShipAlert,
  AutoShipAlertBox,
  AutoShipAlertInfo,
  AutoShipAlertLabel,
  AutoShipButton,
} from './styled'

interface AutoShipNoticeProps {
  status: string
  daysToReactivate: number
  isResuming: boolean
  toggleCancelResumeModal: () => void
  isOrdering: boolean
  restartAutoShip: () => void
}

const AutoShipNotice: React.VFC<AutoShipNoticeProps> = ({
  status,
  daysToReactivate,
  isResuming,
  toggleCancelResumeModal,
  isOrdering,
  restartAutoShip,
}) => {
  const theme = useTheme()

  if (status.includes('Payment Failed')) {
    return (
      <AutoShipAlertBox>
        <AutoShipAlert alertType="warning">
          <AutoShipAlertInfo>
            <ErrorOutlineRounded
              fontSize="small"
              style={{ color: theme.colors.brandYellow.light050 }}
            />
            <AutoShipAlertLabel>Auto-Ship cancelled due to failed payment.</AutoShipAlertLabel>
          </AutoShipAlertInfo>
          {/*<AutoShipButton*/}
          {/*  text={'Update Payment'}*/}
          {/*  disabled={isResuming}*/}
          {/*  onClick={isResuming ? undefined : TODO}*/}
          {/*/>*/}
        </AutoShipAlert>
      </AutoShipAlertBox>
    )
  }

  if (status === 'Suspended' && daysToReactivate > 0) {
    return (
      <AutoShipAlertBox>
        <AutoShipAlert alertType="info">
          <AutoShipAlertInfo>
            <ErrorOutlineRounded fontSize="small" style={{ color: theme.colors.blue.light500 }} />
            <AutoShipAlertLabel>
              {daysToReactivate}{' '}
              {pluralize({
                count: daysToReactivate,
                word: 'day',
              })}{' '}
              to re-activate this Auto-Ship.
            </AutoShipAlertLabel>
          </AutoShipAlertInfo>
          <AutoShipButton
            text={isResuming ? 'Re-Activating...' : 'Re-Activate'}
            disabled={isResuming}
            onClick={isResuming ? undefined : toggleCancelResumeModal}
          />
        </AutoShipAlert>
      </AutoShipAlertBox>
    )
  }

  if (status === 'Suspended' && daysToReactivate <= 0) {
    return (
      <AutoShipAlertBox>
        <AutoShipAlert alertType="info">
          <AutoShipAlertInfo>
            <ErrorOutlineRounded fontSize="small" style={{ color: theme.colors.blue.light400 }} />
            <AutoShipAlertLabel>Auto-Ship expired.</AutoShipAlertLabel>
          </AutoShipAlertInfo>
          <AutoShipButton
            text={isOrdering ? 'Adding to Cart...' : 'Restart'}
            disabled={isOrdering}
            onClick={isOrdering ? undefined : restartAutoShip}
          />
        </AutoShipAlert>
      </AutoShipAlertBox>
    )
  }

  if (status === 'Completed') {
    return (
      <AutoShipAlertBox>
        <AutoShipAlert alertType="info">
          <AutoShipAlertInfo>
            <ErrorOutlineRounded fontSize="small" style={{ color: theme.colors.blue.light400 }} />
            <AutoShipAlertLabel>Auto-Ship completed.</AutoShipAlertLabel>
          </AutoShipAlertInfo>
          <AutoShipButton
            text={isOrdering ? 'Adding to Cart...' : 'Restart'}
            disabled={isOrdering}
            onClick={isOrdering ? undefined : restartAutoShip}
          />
        </AutoShipAlert>
      </AutoShipAlertBox>
    )
  }

  if (status === 'Cancelled') {
    return (
      <AutoShipAlertBox>
        <AutoShipAlert alertType="info">
          <AutoShipAlertInfo>
            <ErrorOutlineRounded fontSize="small" style={{ color: theme.colors.blue.light400 }} />
            <AutoShipAlertLabel>Auto-Ship cancelled.</AutoShipAlertLabel>
          </AutoShipAlertInfo>
          <AutoShipButton
            text={isOrdering ? 'Adding to Cart...' : 'Restart'}
            disabled={isOrdering}
            onClick={isOrdering ? undefined : restartAutoShip}
          />
        </AutoShipAlert>
      </AutoShipAlertBox>
    )
  }

  return null
}

export default AutoShipNotice
